module.exports = __webpack_public_path__ + "fonts/3768D4_1_0.8f3785b.eot";